<template>
    <div>
        <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose">
            <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
                <a-form-model-item
                    ref="group_id"
                    label="分组"
                    prop="group_id"
                    :help="formErr.group_id"
                    :validateStatus='!formErr.group_id||formErr.group_id==""?"":"error"'>
                    <a-select v-model="form.group_id" @change="(e) => { formErr.group_id=''}"
                              :getPopupContainer=" triggerNode => { return triggerNode.parentNode || document.body;} ">
                        <a-select-option :value="item.id" :key="index" v-for="(item,index) in seleList.data">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-form-model>
            <div class="drawer-btn">
                <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                    确定
                </a-button>
                <a-button @click="onClose">
                    取消
                </a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
import {submitForm, drawerConfig, validator} from "@/utils/utils"
import API from "../api";

export default {
    name: "customerForm",
    props: ["visible", "title", "editId"],
    data() {
        return {
            drawerConfig,
            role: [],
            form: {
                group_id: "",
            },
            formErr: {
                group_id: "",
            },
            rules: {
                group_id: [{required: true, message: "请选择分组 "}, {
                    validator: (rule, value, callback) => {
                        validator(rule, value, callback, this.formErr.group_id)
                    }, trigger: "blur"
                }],
            },
            layout: {
                labelCol: {span: 4},
                wrapperCol: {span: 14},
            },
        };
    },
    watch: {
        editId: function (a, b) {
            this.group = a
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        //获取列表数据
        getList() {
            API.ACustomTemplate.GROUP_LIST().then((res) => {
                this.seleList = res.data
                this.loading = false
            });
        },
        onClose() {
            this.$emit("changVisible", false);
            this.formErr = {name: ""}
            this.$refs.ruleForm.resetFields();
        },
        onSubmit() {
            let dataArr = []
            let dataJson = {}
            this.group.map((item) => {
                dataJson = {}
                dataJson.id = item;
                dataJson['group_id'] = this.form.group_id;
                dataArr.push(dataJson)
            })
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    submitForm(API.ACustomTemplate.SET_GROUP, dataArr).then(res => {
                        if (res == true) {
                            this.getList()
                            this.selectedRowKeys = []
                            this.onClose()
                        } else {

                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
    },
}
</script>
<style scoped>

</style>
